module.exports = __webpack_public_path__ + "img/box-clouds-2.2f1ed518.png";